var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFEBE6",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00016H7.33333M7.33333 8.00016H18M7.33333 8.00016V17.3335C7.33333 17.6871 7.47381 18.0263 7.72386 18.2763C7.97391 18.5264 8.31304 18.6668 8.66667 18.6668H15.3333C15.687 18.6668 16.0261 18.5264 16.2761 18.2763C16.5262 18.0263 16.6667 17.6871 16.6667 17.3335V8.00016M9.33333 8.00016V6.66683C9.33333 6.31321 9.47381 5.97407 9.72386 5.72402C9.97391 5.47397 10.313 5.3335 10.6667 5.3335H13.3333C13.687 5.3335 14.0261 5.47397 14.2761 5.72402C14.5262 5.97407 14.6667 6.31321 14.6667 6.66683V8.00016M10.6667 11.3335V15.3335M13.3333 11.3335V15.3335",
    stroke: "#DE350B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete2.9a4d3e1e39c4cc59c215c2f6d41a84a2.svg";
export { ForwardRef as ReactComponent };